export default __webpack_public_path__ + "static/media/floating_tech.04656c88.gif";